
const OT_RATE_KEY = "coco_ot_rate";

export const getOtRate = () => {
  try {
    const raw = localStorage.getItem(OT_RATE_KEY);
    const value = Number(raw);
    return Number.isFinite(value) ? value : 0;
  } catch {
    return 0;
  }
};

export const setOtRate = (rate) => {
  try {
    localStorage.setItem(OT_RATE_KEY, String(Number(rate) || 0));
    return true;
  } catch {
    return false;
  }
};

export const hasOtRate = () => getOtRate() > 0;
